define(['angular'], function (angular) {
    return angular.module('loginCheckServices', []).factory('LoginCheck', [
        '$http',
        '$interval',
        function ($http, $interval) {
            return {
                alertNotLoggedIn: function () {
                    var trigger = $('<div class="reveal-modal small"></div>');
                    trigger.appendTo('body');
                    trigger.foundation(
                        'reveal',
                        'open',
                        Routing.generate('angular_partial', {
                            bundle: 'AppUser',
                            entity: 'User',
                            template: 'partials/logout_warning.html',
                        })
                    );
                },
                checkAuthError: function (response) {
                    if (
                        response.hasOwnProperty('status') &&
                        response.status == 401
                    ) {
                        this.alertNotLoggedIn();
                    }
                },
            };
        },
    ]);
});
